import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  Table,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";

import swal from "sweetalert";
import {
  SetParams,
  getMenuItems,
  menuItemRowData,
  MenuItemDelete,
  model_open,
  model_close,
} from "../../../store/Masters/MenuItems/actions";

class MenuItems extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getMenuItems({ ...this.props.params, page: 1, search: "" });
  }

  deleteRecord = (record) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.MenuItemDelete(record);
      } else {
        swal({ title: "Your imaginary file is safe!", timer: 1500 });
      }
    });
  };

  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getMenuItems({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getMenuItems({ ...this.props.params, page: pageNo });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom">
                    <Link to="/MastersDashboard">
                      <i className="ri-arrow-go-back-fill font-size-18"></i>
                    </Link>
                    <h5 className="card-title-18 d-inline-block ml-2">
                      Menu Items Master
                    </h5>

                    <div className="float-right">
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => this.props.model_open()}
                      >
                        Add Menu Item
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={4}>
                        <FormGroup className="m-0">
                          <InputGroup>
                            <Input
                              type="text"
                              name="search"
                              className="form-control d-inline-block"
                              placeholder="Search"
                              validate={{ required: true }}
                              onChange={(e) =>
                                this.props.SetParams({
                                  ...this.props.params,
                                  search: e.target.value,
                                  page: 1,
                                })
                              }
                              onKeyDown={(e) => this.handleSearch(e)}
                            />
                            <InputGroupAddon addonType="append">
                              <Button
                                color="light"
                                type="submit"
                                onClick={() =>
                                  this.props.getMenuItems({
                                    ...this.props.params,
                                    page: 1,
                                  })
                                }
                              >
                                <i className="ri-search-line"></i>
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={8}>
                        <div className="float-right">
                          <Pagination aria-label="Page navigation example">
                            <PaginationItem
                              disabled={this.props.params.page <= 1}
                            >
                              <PaginationLink
                                onClick={(e) => this.openPage(1)}
                                first
                                // href="#"
                              />
                            </PaginationItem>

                            {this.props.params.page > 2 && (
                              <PaginationItem
                                disabled={this.props.params.page <= 2}
                              >
                                <PaginationLink
                                  onClick={() =>
                                    this.openPage(this.props.params.page - 2)
                                  }
                                  // href="#"
                                >
                                  {this.props.params.page - 2}
                                </PaginationLink>
                              </PaginationItem>
                            )}
                            {this.props.params.page > 1 && (
                              <PaginationItem
                                disabled={this.props.params.page === 1}
                              >
                                <PaginationLink
                                  onClick={() =>
                                    this.openPage(this.props.params.page - 1)
                                  }
                                  // href="#"
                                >
                                  {this.props.params.page - 1}
                                </PaginationLink>
                              </PaginationItem>
                            )}

                            <PaginationItem active={true}>
                              <PaginationLink
                                onClick={() =>
                                  this.openPage(this.props.params.page)
                                }
                                // href="#"
                              >
                                {this.props.params.page}
                              </PaginationLink>
                            </PaginationItem>
                            {this.props.params.page + 1 <=
                              this.props.params.no_of_pages && (
                              <PaginationItem
                                disabled={
                                  this.props.params.page + 1 >
                                  this.props.params.no_of_pages
                                }
                              >
                                <PaginationLink
                                  onClick={() =>
                                    this.openPage(this.props.params.page + 1)
                                  }
                                  // href="#"
                                >
                                  {this.props.params.page + 1}
                                </PaginationLink>
                              </PaginationItem>
                            )}
                            {this.props.params.page + 2 <=
                              this.props.params.no_of_pages && (
                              <PaginationItem
                                disabled={
                                  this.props.params.page + 2 >
                                  this.props.params.no_of_pages
                                }
                              >
                                <PaginationLink
                                  onClick={() =>
                                    this.openPage(this.props.params.page + 2)
                                  }
                                  // href="#"
                                >
                                  {this.props.params.page + 2}
                                </PaginationLink>
                              </PaginationItem>
                            )}
                            {this.props.params.page + 3 <=
                              this.props.params.no_of_pages &&
                              this.props.params.page < 3 && (
                                <PaginationItem
                                  disabled={
                                    this.props.params.page + 3 >
                                    this.props.params.no_of_pages
                                  }
                                >
                                  <PaginationLink
                                    onClick={() =>
                                      this.openPage(this.props.params.page + 3)
                                    }
                                    // href="#"
                                  >
                                    {this.props.params.page + 3}
                                  </PaginationLink>
                                </PaginationItem>
                              )}
                            {this.props.params.page + 4 <=
                              this.props.params.no_of_pages &&
                              this.props.params.page < 2 && (
                                <PaginationItem
                                  disabled={
                                    this.props.params.page + 4 >
                                    this.props.params.no_of_pages
                                  }
                                >
                                  <PaginationLink
                                    onClick={() =>
                                      this.openPage(this.props.params.page + 4)
                                    }
                                    // href="#"
                                  >
                                    {this.props.params.page + 4}
                                  </PaginationLink>
                                </PaginationItem>
                              )}

                            <PaginationItem
                              disabled={
                                this.props.params.no_of_pages ===
                                this.props.params.page
                              }
                            >
                              <PaginationLink
                                onClick={(e) =>
                                  this.openPage(this.props.params.no_of_pages)
                                }
                                last
                                // href="#"
                              />
                            </PaginationItem>
                          </Pagination>
                        </div>
                      </Col>
                    </Row>
                    <div
                      className="table-responsive m-0"
                      style={{
                        maxHeight: "550px",
                        overflowY: "auto",
                      }}
                    >
                      <Table
                        // striped
                        bordered
                        hover
                        responsive
                        className="mb-0 p-0 table-centered"
                      >
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">Code</th>
                            <th className="nowrap">Menu</th>
                            <th className="nowrap">Menu title</th>
                            <th className="nowrap">Menu Link</th>
                            <th className="nowrap">Menu Sequence</th>
                            <th className="nowrap">Menu Icon</th>
                            <th className="nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.MenuItemsList.map((MenuItem, key) => (
                            <tr key={key}>
                              <td className="text-center">{MenuItem.code}</td>
                              <td>{MenuItem.menu?.name}</td>

                              <td>{MenuItem.title}</td>
                              <td>{MenuItem.link}</td>
                              <td>{MenuItem.sequence}</td>
                              <td>{MenuItem.icon}</td>

                              <td className="nowrap text-center">
                                <i
                                  className="mdi mdi-pencil-box-outline mr-2 font-size-18"
                                  title="Edit Product"
                                  style={{
                                    cursor: "pointer",
                                    color: "#fc6f03",
                                  }}
                                  onClick={() =>
                                    this.props.menuItemRowData(MenuItem.id)
                                  }
                                ></i>

                                <i
                                  className="mdi mdi-delete mr-2 font-size-18"
                                  title="Delete Product"
                                  style={{
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => this.deleteRecord(MenuItem.id)}
                                ></i>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { MenuItemsList, model, rowdata, params } = state.MenuItems;
  return { MenuItemsList, model, rowdata, params };
};

export default connect(mapStatetoProps, {
  getMenuItems,
  SetParams,
  menuItemRowData,
  MenuItemDelete,
  model_open,
  model_close,
})(MenuItems);
